import CommitDiffsFileOptionsDropdown from '../app/options_menu/commit_diffs_file_options_dropdown.vue?vue3';
import { createOptionsMenuAdapter } from './options_menu.js?vue3';
import { commitDiffDiscussionsStore } from '../stores/instances/commit_discussions.js?vue3';

export const commitDiffsOptionsMenuAdapter = createOptionsMenuAdapter(
  CommitDiffsFileOptionsDropdown,
  commitDiffDiscussionsStore,
);
